import { environment as env } from "../../../../../environments/environment";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomerService {

    constructor(private http: HttpClient) {}

    public getCustomer(id) {
        const url = `${env.apiPath}/clients/${id}`;
        return this.http.get(url);
    }

    public getCustomerSiblings(id) {
        const url = `${env.apiPath}/clients/${id}/siblings`;
        return this.http.get(url);
    }
};
